import { useEffect, useMemo } from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { CommonEnums } from "../../../../../enums/common.enums";
import PropertyJourneyTabs from "./PropertyJourneyTabs";
import PropertyPostJourneyConfiguration from "./PropertyPostConfiguration";
import PropertyJourneyInfo from "./PropertyInfo";
import ProtectedComponent from "../../../../../components/ProtectedComponent";
import NavigationLayout from "../../../navigation";
import BackArrowIcon from "../../../../../components/icons/BackArrowIcon";
import { clientRoutes } from "../../../../../utils/routes";
import "./PropertyPostJourneyView.scss";
import { PropertyApi } from "../../../../../utils/api/Property";
import PropertyCustomizePost from "../PropertyCustomizePost";

const PropertyPostJourneyView = () => {
  const { propertyPostId } = useParams<{ propertyPostId: string }>();
  const [searchParams, setSearchParams] = useSearchParams();
  const navigate = useNavigate();

  const step = useMemo(() => {
    return (
      searchParams.get("step") ||
      CommonEnums.propertyPostJourney.property_info.key
    );
  }, [searchParams]);

  useEffect(() => {
    const next = new URLSearchParams(searchParams);

    if (!next.get("step")) {
      next.set("step", CommonEnums.propertyPostJourney.property_info.key);
    }

    if (next.toString() !== searchParams.toString()) {
      setSearchParams(next, { replace: true });
    }
  }, [propertyPostId, searchParams, setSearchParams]);

  const handleBackToList = () => {
    const subscriptionType = searchParams.get("subscription_type");
    const backUrl = subscriptionType
      ? `${clientRoutes.PropertyPostList}?subscription_type=${subscriptionType}`
      : clientRoutes.PropertyPostList;

    navigate(backUrl);
  };

  if (step === "customize_post") {
    if (!propertyPostId) {
      return <div style={{ padding: 20 }}>Missing property_post_id.</div>;
    }

    return (
      <PropertyCustomizePost
        propertyPostId={propertyPostId}
        postType={searchParams.get("post_type") || "image_post"}
        subscriptionType={searchParams.get("subscription_type") || ""}
        onBackToConfigure={() => {
          setSearchParams((prev) => {
            const next = new URLSearchParams(prev);
            next.set("step", CommonEnums.propertyPostJourney.post_system.key);
            return next;
          });
        }}
        onSaved={() => {
          setSearchParams((prev) => {
            const next = new URLSearchParams(prev);
            next.set("step", CommonEnums.propertyPostJourney.post_system.key);
            return next;
          });
        }}
      />
    );
  }

  // useEffect(() => {
  //   const ensureTemplateInQuery = async () => {
  //     if (!propertyPostId) return;

  //     const step =
  //       searchParams.get("step") || CommonEnums.propertyPostJourney.property_info.key;

  //     if (step !== CommonEnums.propertyPostJourney.post_system.key) return;

  //     if (searchParams.get("template_type")) return;

  //     const res = await PropertyApi.getPropertyPostById(propertyPostId);
  //     if (!res?.data?.success) return;

  //     const post = res.data.data;
  //     if (!post?.template_type) return;

  //     const next = new URLSearchParams(searchParams);
  //     next.set("template_type", post.template_type);
  //     next.set("selected_slug", post.template_type);

  //     setSearchParams(next, { replace: true });
  //   };

  //   ensureTemplateInQuery();
  // }, [propertyPostId, searchParams, setSearchParams]);

  return (
    <ProtectedComponent>
      <NavigationLayout>
        <div className="property-post-journey-view">
          <div className="manage-invites-list-heading">
            <div className="propertie-view-back-btn" onClick={handleBackToList}>
              <div className="back-icon">
                <BackArrowIcon />
              </div>
              <p className="bakc-text-contain">Back to Property Post List</p>
            </div>

            <p className="page-title">Property marketing journey</p>
          </div>
          <PropertyJourneyTabs
            activeTab={step}
            onTabChange={(tab) => {
              const next = new URLSearchParams(searchParams);
              next.set("step", tab);
              setSearchParams(next);
            }}
          />

          {step === CommonEnums.propertyPostJourney.post_system.key ? (
            <PropertyPostJourneyConfiguration />
          ) : (
            <PropertyJourneyInfo />
          )}
        </div>
      </NavigationLayout>
    </ProtectedComponent>
  );
};

export default PropertyPostJourneyView;
